import { MatchedPro, WeightedMatch } from '../../../shared/types';

// The weighted match is deliberately slim: the Results page loads the full card from the referral
// once one exists. Only the no_referral test path renders this stored match directly, so the
// display fields the match doesn't carry stay empty.
function toMatchedPro(match: WeightedMatch): MatchedPro {
  return {
    companyName: match.companyName ?? '',
    headProName: match.headProName ?? '',
    officeExternalKey: match.officeExternalKey,
    partnershipURN: match.partnershipUrn,
    matchResultKey: match.matchResultKey,
    photoUrl: null,
    phone: null,
    email: null,
    website: null,
    street: null,
    city: '',
    state: '',
    postalCode: null,
    matchScore: match.score,
    distanceScore: match.distanceScore,
    categoryScore: match.categoryScore,
    distanceMiles: match.distanceMiles,
    specializations: [],
    industriesServed: [],
    credentials: [],
    designations: [],
    schedulingLink: null
  };
}

export { toMatchedPro };
